import { BaseNode } from './base/BaseNode';

export class CodeBlock extends BaseNode {
  constructor() {
    super('code_block');
  }

  get schema() {
    return {
      content: 'text*',
      marks: '',
      group: 'block',
      code: true,
      defining: true,
      parseDOM: [{ tag: 'pre', preserveWhitespace: true }],
      toDOM() {
        return ['pre', ['code', 0]] as const;
      },
    };
  }
}
